import { Button } from "@/components/ui/button"
import { DropdownMenu, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuTrigger } from "@/components/ui/dropdown-menu"
import { Table } from "@tanstack/react-table"
import { capitalCase } from "change-case"
import { ChevronDown, Columns2 } from "lucide-react"

/** The label a column shows in the "Columns" picker: its `columnPickerLabel` meta, else its id in words. */
export function column_visibility_menu_label(column: { id: string; columnDef: { meta?: unknown } }): string {
  const meta = column.columnDef.meta as { columnPickerLabel?: string } | undefined
  if (meta?.columnPickerLabel) return meta.columnPickerLabel
  return capitalCase(column.id)
}

interface ColumnVisibilityMenuProps<TData> {
  table: Table<TData>
  className?: string
}

/** The "Columns" dropdown every table toolbar carries: one checkbox per hideable column. */
export function ColumnVisibilityMenu<TData>({ table, className }: ColumnVisibilityMenuProps<TData>) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className={className ?? "ml-auto text-slate-500"}>
          <Columns2 className="h-4" />
          Columns
          <ChevronDown className="h-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="overflow-y-scroll"
        style={{ maxHeight: "var(--radix-dropdown-menu-content-available-height)" }}>
        {table
          .getAllColumns()
          .filter(column => column.getCanHide())
          .sort((a, b) => a.id.localeCompare(b.id))
          .map(column => {
            return (
              <DropdownMenuCheckboxItem
                key={column.id}
                checked={column.getIsVisible()}
                onCheckedChange={(value: any) => column.toggleVisibility(!!value)}>
                {column_visibility_menu_label(column)}
              </DropdownMenuCheckboxItem>
            )
          })}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
